import { createHashHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router'
import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import search_reducer from '../Store/search_reducer'
import guestbook_reducer from '../Store/guestbook_reducer'
import thunk from 'redux-thunk'

export const history = createHashHistory()

const createRootReducer = (history) => combineReducers({
    router: connectRouter(history),
    basic: search_reducer,
    guest: guestbook_reducer
})

const logger = store => {
    return next => {
        return action => {
            console.log("[Middleware]", action);
            const result = next(action)
            console.log("[Middleware After]", store.getState());
            return result;
        }
    }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(preloadedState) {
    const store = createStore(
        createRootReducer(history), // root reducer with router state
        preloadedState,
        composeEnhancers(
            applyMiddleware(
                routerMiddleware(history),
                logger,
                thunk
            ))
    )
    return store
}